import {
    Card as UiCard,
    Skeleton as UiSkeleton,
    styled,
    styledForMobile,
    Typography as UiTypography,
    Chip,
    Typography,
} from "@l2r-front/l2r-ui"

import { TECHNIQUE_BUTTON_CONTAINER_HEIGHT } from "../../constants/layout"

import { TaskImpactBadge } from "../TaskImpactBadge"

const CARD_MINHEIGHT = 125
const CARD_WIDTH = 195
const CARD_MOBILE_WIDTH = 150

type StyledCardProps = {
    selected?: boolean
    disabled?: boolean
}

export const Card = styled(UiCard, { shouldForwardProp: (prop) => prop !== "selected" && prop !== "disabled" })<StyledCardProps>(({ selected, disabled, theme }) => ({
    backgroundColor: disabled ? theme.palette["action/disabledBackground"].main : "white",
    border: `solid 2px ${selected ? theme.palette["primary"].main : "transparent"}`,
    borderRadius: `${theme.spacing(3)} !important`,
    padding: theme.spacing(3),
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    maxHeight: "100% !important",
    minHeight: CARD_MINHEIGHT,
    height: "100%",
    width: "100%",

    ":hover": {
        boxShadow: theme.customShadow("LCS/Shadow-simple"),
        cursor: "pointer",
    },
}))

export const TextWrapper = styled("div")({
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-between",
})

export const BadgeWrapper = styled("div")({
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
})

export const ColoredBadge = styled(TaskImpactBadge)({
    height: "fit-content",
})

export const DoneAtWrapper = styled("div")(({ theme }) => ({
    display: "flex",
    flexDirection: "row",
    gap: theme.spacing(2),
}))

export const ButtonsWrapper = styled("div")(() => ({
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    height: TECHNIQUE_BUTTON_CONTAINER_HEIGHT,
}))

export const Element = styled("div")(({ theme }) => ({
    marginTop: theme.spacing(2),
    textAlign: "left",
}))

export const Skeleton = styledForMobile(UiSkeleton, ["alignRight"])(({ alignRight, isMobile, theme }) => ({
    display: "flex",
    flexDirection: "column",
    height: "100%",
    marginLeft: !!alignRight && "auto",
    minHeight: CARD_MINHEIGHT,
    padding: theme.spacing(3),
    transform: "scale(1)",
    width: isMobile ? CARD_MOBILE_WIDTH : CARD_WIDTH,
}))

export const Error = styled(UiTypography)(({ theme }) => ({
    color: theme.palette["error"].main,
    margin: "auto",
}))

export const StatusChip = styled(Chip, {
    shouldForwardProp: (prop) => prop !== "closed",
})(({ theme }) => ({
    backgroundColor: "transparent",
    borderRadius: theme.spacing(2),
    border: `1px solid ${theme.palette.divider}`,
    fontSize: theme.typography["Desktop & Mobile/Body/Small"].fontSize,

    "& > .MuiChip-label": {
        color: theme.palette["text/secondary"].main,
    },
}))

export const HeaderRight = styled("div")(({ theme }) => ({
    alignItems: "center",
    display: "flex",
    justifyContent: "space-between",
    gap: theme.spacing(2),
}))

export const ContentWrapper = styled("div")({
    display: "flex",
    flexDirection: "column",
    height: "100%",
})

export const BottomElementsWrapper = styled("div")({
    marginTop: "auto",
})

export const Cost = styled(Typography)({
    marginLeft: "auto",
    textAlign: "right",
})